import React from "react";
import { RuleTagRow } from "../RuleTagRow";

interface Props {
    value: string;
}

export const RuleMemoAction: React.FC<Props> = ({ value }) => (
    <RuleTagRow label="Add memo" type="action" values={[value]} />
);
